import { computed, type WritableComputedRef } from 'vue';
import type { SearchFormCriteria } from '@/widgets/searchForm';
import { EMPTY_CRITERIA, type SerpPageProps } from '../model/types';

export function useSerpCriteria(
  props: Pick<SerpPageProps, 'modelValue'>,
  emit: (event: 'update:modelValue', criteria: SearchFormCriteria) => void,
): WritableComputedRef<SearchFormCriteria> {
  return computed<SearchFormCriteria>({
    get: () => props.modelValue || EMPTY_CRITERIA,
    set: (value) => emit('update:modelValue', value),
  });
}
